import * as Sentry from "@sentry/react"

import { isBackstage } from "@components"


const setSentryUser = (identity, isImpersonated = false) => {
  if (!identity) {
    Sentry.setUser()
    return
  }

  const {
    id,
    correlationId,
    organization: {
      id: organizationId,
      name: organizationName
    },
    roles
  } = identity

  let fullName
  let email

  if (isBackstage) {
    fullName = `${identity.givenName} ${identity.familyName}`
    email = identity.email

  } else {
    fullName = `${identity.investor.givenName} ${identity.investor.familyName}`
    email = identity.investor.email

  }

  const sentryUser = {
    "Cognito ID": correlationId,
    id,
    "Name": fullName,
    email,
    "Impersonated": isImpersonated,
    "Organization": organizationName,
    "Organization ID": organizationId,
    roles
  }

  // eslint-disable-next-line no-console
  console.info('setSentryUser', sentryUser)

  Sentry.setUser(sentryUser)
}

export default setSentryUser
